import { styled } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { tooltipClasses } from '@mui/material/Tooltip';
import LinkComp from 'components/atoms/LinkComp';
import TagComponent from 'components/mocules/TagComponent';
import { MISSING_IMAGE } from 'constants/Images';
import { DOMAIN_WEB_HOST } from 'sysconfig';
import { ImageFallbackProductImage } from 'utils/ImageFallback';
import styles from './styles.module.css';
import { useEffect, useState } from 'react';
import ProductServiceV2 from 'services/ProductServiceV2';

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#A2A0A0',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#A2A0A0',
    color: '#fff',
    fontSize: 12,
    top: '-2px',
  },
}));

export default function ComboList({ skus }) {
  const [comboList, setComboList] = useState([]);

  useEffect(() => {
    if (skus?.length > 0) {
      const comboList = skus?.map((item) => ({
        ...item,
        ...ProductServiceV2.convertProductV2(item.productData),
        quantity: item.quantity,
      }));
      setComboList(comboList);
    }
  }, []);

  if (comboList?.length === 0) return null;

  return (
    <>
      <Typography className={styles.titleCombo}>Combo bao gồm</Typography>
      <div className={styles.comboContainer}>
        {comboList.map((item, index) => {
          const isLinkActive = item?.sellerClass === 'INTERNAL' && item?.isActive;
          const tagExpired = item?.productData?.sku?.lotDates?.find((ele) => ele?.isNearExpired === true) || {};
          const { expiredDate = '' } = tagExpired;
          return (
            <div className={styles.comboItem} key={`${item.sku + index}`}>
              <LinkComp
                style={{ pointerEvents: isLinkActive || !item?.isGift ? '' : 'none' }}
                removeStyles
                href={`${DOMAIN_WEB_HOST}/product/${item?.productData?.sku?.slug || ''}`}
              >
                <div className={styles.imageContainer}>
                  <ImageFallbackProductImage
                    src={item?.productData?.product?.imageUrls?.length > 0 && item?.productData?.product?.imageUrls[0]}
                    size="thumbnail"
                    width={38}
                    height={38}
                    alt={item?.productData?.product?.name}
                  />
                </div>
              </LinkComp>
              <div className={styles.groupInfoProduct}>
                {isLinkActive || !item?.isGift ? (
                  <LinkComp removeStyles href={`${DOMAIN_WEB_HOST}/product/${item?.productData?.sku?.slug || ''}`}>
                    <LightTooltip title={item?.productData?.product?.name} arrow placement="top">
                      <Typography className={styles.nameCombo}>{item?.productData?.product?.name}</Typography>
                    </LightTooltip>
                  </LinkComp>
                ) : (
                  <LightTooltip title={item?.productData?.product?.name} arrow placement="top">
                    <Typography className={styles.nameCombo}>{item?.productData?.product?.name}</Typography>
                  </LightTooltip>
                )}
                <div className={styles.hightLightTag}>
                  <TagComponent
                    product={{
                      tags: item?.productData?.sku?.tags,
                      statusData: item?.productData?.sku?.status,
                      expiredDate,
                    }}
                    isMobile
                    isSellerList={false}
                    isPageDetail
                  />
                </div>
                <Typography className={styles.priceCombo}>
                  {item.salePriceFormated || 0} <span className={styles.quantity}>x {item?.quantity} sản phẩm</span>
                </Typography>
              </div>
              {index === comboList.length - 1 ? null : (
                <div className={styles.addContainer}>
                  <div className={styles.addIcon} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

